var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 207,
    viewBox: "0 0 194 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.174 60.8135L150.395 20.5703L182.599 46.0105L144.174 60.8135Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.542 25.9316L149.373 46.4356",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.792 57.268L163.386 53.4121L166.474 55.8495L162.792 57.268Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.28 152.718L108.345 157.487L111.627 169.34L116.743 165.556L119.819 151.174L113.163 145.519L110.386 145.188L108.554 146.053L84.8184 161.179",
    fill: "#EDD6BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.28 152.718L108.345 157.487L111.627 169.34L116.743 165.556L119.819 151.174L113.163 145.519L110.386 145.188L108.554 146.053L84.8184 161.179",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.694 165.97L115.451 164.051C115.451 164.051 114.758 151.967 114.34 149.875C113.857 147.462 111.608 145.764 109.127 145.998C109.107 146 109.087 146.001 109.067 146.003L108.554 146.054L110.604 144.587C110.938 144.348 111.409 144.083 111.933 143.817C113.905 142.816 116.309 143.212 117.825 144.809L117.961 144.952C118.65 145.678 119.14 146.563 119.406 147.522C119.981 149.587 121.546 165.566 121.546 165.566C121.822 168.695 120.314 172.965 118.89 176.062C118.493 176.924 117.645 177.513 116.687 177.549C116.674 177.549 116.661 177.55 116.648 177.55C115.139 177.595 113.773 176.673 113.268 175.269L108.961 159.709",
    fill: "#B4FF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.694 165.97L115.451 164.051C115.451 164.051 114.758 151.967 114.34 149.875C113.857 147.462 111.608 145.764 109.127 145.998C109.107 146 109.087 146.001 109.067 146.003L108.554 146.054L110.604 144.587C110.938 144.348 111.409 144.083 111.933 143.817C113.905 142.816 116.309 143.212 117.825 144.809L117.961 144.952C118.65 145.678 119.14 146.563 119.406 147.522C119.981 149.587 121.546 165.566 121.546 165.566C121.822 168.695 120.314 172.965 118.89 176.062C118.493 176.924 117.645 177.513 116.687 177.549C116.674 177.549 116.661 177.55 116.648 177.55C115.139 177.595 113.773 176.673 113.268 175.269L108.961 159.709",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.554 146.055L98.0898 151.185C102.002 152.074 104.951 154.426 105.722 157.632C106.209 159.656 105.579 161.785 104.208 163.365L110.731 155.848",
    fill: "#EDD6BF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.554 146.055L98.0898 151.185C102.002 152.074 104.951 154.426 105.722 157.632C106.209 159.656 105.579 161.785 104.208 163.365L110.731 155.848",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6372 147.089L60.4781 178.494C60.4507 185.136 65.9178 190.525 72.6482 190.491C77.3066 190.468 81.7424 188.521 84.8797 185.122L109.791 162.552L108.24 154.867C107.684 152.112 106.012 149.7 103.611 148.191L85.9562 155.931L81.8598 166.065L100.242 126.266L88.1328 108.559",
    fill: "#C4DFE9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6372 147.089L60.4781 178.494C60.4507 185.136 65.9178 190.525 72.6482 190.491C77.3066 190.468 81.7424 188.521 84.8797 185.122L109.791 162.552L108.24 154.867C107.684 152.112 106.012 149.7 103.611 148.191L85.9562 155.931L81.8598 166.065L100.242 126.266L88.1328 108.559",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.431 152.449L122.497 157.218L125.778 169.07L130.895 165.287L133.971 150.904L127.315 145.249L124.538 144.918L122.705 145.784L98.9702 160.91",
    fill: "#EDD6BF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.431 152.449L122.497 157.218L125.778 169.07L130.895 165.287L133.971 150.904L127.315 145.249L124.538 144.918L122.705 145.784L98.9702 160.91",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.845 165.699L130.895 165.286C130.895 165.286 128.91 151.695 128.491 149.603C128.008 147.19 125.759 145.492 123.278 145.726C123.258 145.728 123.238 145.73 123.219 145.732L122.706 145.783L124.756 144.315C125.089 144.077 125.56 143.811 126.085 143.545C128.057 142.544 130.461 142.94 131.977 144.538L132.113 144.681C132.801 145.407 133.291 146.291 133.558 147.25C134.132 149.316 135.697 165.294 135.697 165.294C135.973 168.423 134.466 172.694 133.041 175.791C132.645 176.652 131.796 177.241 130.838 177.277C130.825 177.278 130.812 177.278 130.799 177.279C129.29 177.323 127.925 176.401 127.42 174.997L123.112 159.438",
    fill: "#B4FF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.845 165.699L130.895 165.286C130.895 165.286 128.91 151.695 128.491 149.603C128.008 147.19 125.759 145.492 123.278 145.726C123.258 145.728 123.238 145.73 123.219 145.732L122.706 145.783L124.756 144.315C125.089 144.077 125.56 143.811 126.085 143.545C128.057 142.544 130.461 142.94 131.977 144.538L132.113 144.681C132.801 145.407 133.291 146.291 133.558 147.25C134.132 149.316 135.697 165.294 135.697 165.294C135.973 168.423 134.466 172.694 133.041 175.791C132.645 176.652 131.796 177.241 130.838 177.277C130.825 177.278 130.812 177.278 130.799 177.279C129.29 177.323 127.925 176.401 127.42 174.997L123.112 159.438",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5143 133.663L75.7857 178.835C75.5375 185.322 80.4712 190.868 87.0209 191.465C90.8021 191.809 94.5281 190.384 97.0855 187.614L123.928 156.678L120.471 146.881L104.346 154.791L98.2221 170.952L108.058 144.993C110.849 137.629 111.126 129.568 108.856 122.031C108.029 119.285 107.168 116.553 106.419 114.44L101.102 110.775L62.4287 114.029L61.7603 119.321C61.0527 124.924 59.7059 130.387 59.6827 136.033L59.6372 147.09",
    fill: "#C4DFE9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5143 133.663L75.7857 178.835C75.5375 185.322 80.4712 190.868 87.0209 191.465C90.8021 191.809 94.5281 190.384 97.0855 187.614L123.928 156.678L120.471 146.881L104.346 154.791L98.2221 170.952L108.058 144.993C110.849 137.629 111.126 129.568 108.856 122.031C108.029 119.285 107.168 116.553 106.419 114.44L101.102 110.775L62.4287 114.029L61.7603 119.321C61.0527 124.924 59.7059 130.387 59.6827 136.033L59.6372 147.09",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.705 145.783L112.242 150.913C116.154 151.802 119.103 154.154 119.874 157.36C120.36 159.384 119.731 161.514 118.36 163.094L124.883 155.576",
    fill: "#EDD6BF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122.705 145.783L112.242 150.913C116.154 151.802 119.103 154.154 119.874 157.36C120.36 159.384 119.731 161.514 118.36 163.094L124.883 155.576",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7044 23.8426L50.4156 18.5736L44.437 14.1889C44.0817 13.9283 43.9814 13.4459 44.2039 13.0682C44.4471 12.6558 44.9842 12.5183 45.3999 12.7617L50.5162 15.7603L44.7116 9.00409C44.4038 8.64574 44.4287 8.11344 44.769 7.78463C45.1281 7.43745 45.7047 7.44439 46.055 7.80026L52.2203 14.0584L47.439 5.05064C47.1974 4.59526 47.3676 4.03294 47.8225 3.78304C48.2799 3.53165 48.857 3.68824 49.12 4.13493L54.2962 12.9277L51.6329 4.13865C51.5039 3.71281 51.7139 3.25843 52.124 3.07528C52.5865 2.86881 53.1301 3.0805 53.3255 3.54282L58.1438 14.952L59.2603 9.96943C59.5078 8.86536 60.5662 8.12882 61.7033 8.26953L61.2288 10.5958L61.4513 20.2383L68.097 31.1859L59.4213 33.6129L55.7051 23.8426H55.7044Z",
    fill: "#EDD6BF",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1434 14.9512L57.4476 15.3448C55.8881 16.2272 54.7693 17.7087 54.3584 19.4357",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1658 67.1552L65.0912 23.917L64.5832 20.6328L62.1096 22.1545C59.6988 23.6375 57.3036 27.1976 56.8545 29.9659L58.2378 30.5029L76.2828 78.3899",
    fill: "#B4FF00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1658 67.1552L65.0912 23.917L64.5832 20.6328L62.1096 22.1545C59.6988 23.6375 57.3036 27.1976 56.8545 29.9659L58.2378 30.5029L76.2828 78.3899",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9843 68.0117L73.224 80.7074C71.9023 81.966 71.2663 83.7702 71.5115 85.5663L72.6421 93.8507L68.7286 100.047C63.8147 107.827 59.8954 117.047 56.4961 125.579L56.1657 126.409L53.1597 127.922C70.2124 142.617 95.1976 137.912 108.948 128.655C112.026 126.583 116.02 123.356 118.115 120.315L103.425 107.977L115.682 77.4324L111.473 72.2394L101.518 72.3009L95.0983 73.5306L89.9848 68.0117",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9843 68.0117L73.224 80.7074C71.9023 81.966 71.2663 83.7702 71.5115 85.5663L72.6421 93.8507L68.7286 100.047C63.8147 107.827 59.8954 117.047 56.4961 125.579L56.1657 126.409L53.1597 127.922C70.2124 142.617 95.1976 137.912 108.948 128.655C112.026 126.583 116.02 123.356 118.115 120.315L103.425 107.977L115.682 77.4324L111.473 72.2394L101.518 72.3009L95.0983 73.5306L89.9848 68.0117",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2708 71.5813C94.4912 74.7828 104.551 76.643 115.115 76.8411L110.739 72.2791C110.566 72.2677 110.391 72.258 110.218 72.2456L101.518 72.3L95.098 73.5296L90.6332 68.7108C90.2573 68.5996 89.8821 68.487 89.5087 68.3711L85.2705 71.5813H85.2708Z",
    fill: "#002340"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M112.423 85.5525L114.164 81.2121C102.406 80.8871 91.2467 78.5938 81.111 74.7324L77.0161 77.8342C87.8145 82.2842 99.7784 85.0082 112.423 85.5527V85.5525Z",
    fill: "#002340"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110.687 89.8777C97.1905 89.1069 84.4501 85.9595 73.019 80.9258C71.9576 82.049 71.4023 83.5404 71.4745 85.0691C82.9056 90.067 95.5663 93.2539 108.956 94.1914L110.687 89.8777Z",
    fill: "#002340"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6423 93.8492L71.9971 94.8711C82.4248 98.9672 93.6911 101.696 105.505 102.794L107.229 98.496C94.7915 97.4773 82.9707 94.5889 72.1382 90.1543L72.6423 93.8494V93.8492Z",
    fill: "#002340"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.822 111.545C105.24 111.687 106.667 111.804 108.098 111.901L103.425 107.976L103.787 107.075C91.7328 105.832 80.2329 102.958 69.5829 98.6934L68.7287 100.046C68.2152 100.859 67.715 101.691 67.2227 102.533C78.5971 107.163 90.9075 110.261 103.822 111.545Z",
    fill: "#002340"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1895 119.836C104.509 120.681 110.974 121.114 117.524 121.109C117.732 120.843 117.933 120.578 118.115 120.314L113.706 116.611C109.453 116.501 105.244 116.202 101.097 115.718C88.3975 114.245 76.2825 111.072 65.0481 106.451C64.3568 107.762 63.6872 109.095 63.0366 110.441C74.0284 114.99 85.8316 118.195 98.1895 119.837V119.836Z",
    fill: "#002340"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M113.138 125.5C107.029 125.326 101.001 124.784 95.1003 123.894C83.195 122.107 71.8029 118.917 61.1481 114.494C60.5368 115.854 59.9433 117.217 59.3652 118.579C69.5963 122.828 80.4769 125.981 91.831 127.884C96.9136 128.74 102.091 129.343 107.335 129.685C107.888 129.348 108.427 129.004 108.948 128.653C110.252 127.776 111.719 126.69 113.138 125.5Z",
    fill: "#002340"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3824 131.802C77.6673 129.815 67.3776 126.741 57.652 122.707C57.2602 123.67 56.8745 124.629 56.496 125.579L56.1656 126.408L55.584 126.701C64.8479 130.567 74.6123 133.575 84.7563 135.641C86.2138 135.94 87.6803 136.216 89.1532 136.475C92.8328 135.808 96.3757 134.777 99.6553 133.482C95.8539 133.056 92.0925 132.494 88.3824 131.802Z",
    fill: "#002340"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M171.466 80.034L178.79 81.6952L185.717 84.4006C186.128 84.5614 186.596 84.3914 186.804 84.0058C187.031 83.5846 186.867 83.0615 186.438 82.8412L181.161 80.1288L190.037 81.4391C190.508 81.5085 190.953 81.2073 191.057 80.7487C191.167 80.2645 190.857 79.7846 190.367 79.6781L181.729 77.8028L192.006 77.0687C192.526 77.0315 192.92 76.5927 192.896 76.0793C192.872 75.5631 192.433 75.1616 191.91 75.1762L181.609 75.4658L190.582 73.0703C191.017 72.9542 191.298 72.5388 191.24 72.098C191.174 71.6015 190.705 71.2568 190.204 71.3364L177.839 73.3046L181.543 69.7435C182.364 68.9543 182.44 67.6783 181.72 66.7988L179.966 68.4223L171.544 73.315L158.623 73.3222L160.171 82.4791L171.466 80.034Z",
    fill: "#EDD6BF",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M177.839 73.3047L177.867 74.0956C177.928 75.8687 177.241 77.5874 175.97 78.8419",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M106.087 72.269L164.431 71.9539L167.092 69.7227L167.86 72.851C168.527 75.5658 168.266 78.4219 167.119 80.9757L108.939 93.9679",
    fill: "#B4FF00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M106.087 72.269L164.431 71.9539L167.092 69.7227L167.86 72.851C168.527 75.5658 168.266 78.4219 167.119 80.9757L108.939 93.9679",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7495 37.7342L122.996 21.3457L116.221 48.7362L99.7495 37.7342Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M121.865 25.9183L122.996 21.3457L116.384 26.0069L121.865 25.9183Z",
    fill: "#B4FF00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M119.402 35.8738L120.63 30.9121L109.163 31.098L101.989 36.1557L119.402 35.8738Z",
    fill: "#B4FF00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.94 45.8287L118.167 40.8672L104.765 41.0841L111.988 45.9091L116.94 45.8287Z",
    fill: "#B4FF00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7495 37.7342L122.996 21.3457L116.221 48.7362L99.7495 37.7342Z",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4645 66.7024L89.1224 70.3564L89.9845 68.0097C84.1173 72.0488 84.3617 76.6683 88.0024 79.4348C93.3616 83.5074 104.862 82.0194 103.216 72.4823C103.208 72.4335 103.221 72.3836 103.223 72.3342L101.518 72.299L101.517 73.373L101.516 74.7232L101.522 64.9718L112.211 62.3001L107.656 45.6607L98.9803 40.0527L95.53 43.8168L91.0678 49.7727C90.9415 49.9414 90.8188 50.1124 90.6999 50.2856C89.0545 52.6834 88.2312 55.5389 88.1769 58.4342L88.0771 63.7459C87.9813 64.9941 88.7596 66.1463 89.9641 66.5392L91.0421 66.8908",
    fill: "#EDD6BF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4645 66.7024L89.1224 70.3564L89.9845 68.0097C84.1173 72.0488 84.3617 76.6683 88.0024 79.4348C93.3616 83.5074 104.862 82.0194 103.216 72.4823C103.208 72.4335 103.221 72.3836 103.223 72.3342L101.518 72.299L101.517 73.373L101.516 74.7232L101.522 64.9718L112.211 62.3001L107.656 45.6607L98.9803 40.0527L95.53 43.8168L91.0678 49.7727C90.9415 49.9414 90.8188 50.1124 90.6999 50.2856C89.0545 52.6834 88.2312 55.5389 88.1769 58.4342L88.0771 63.7459C87.9813 64.9941 88.7596 66.1463 89.9641 66.5392L91.0421 66.8908",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M116.521 47.6797L118.401 39.9209C118.401 39.9209 121.977 31.3453 133.698 39.4899C142.918 45.8966 147.848 45.205 147.848 45.205L147.816 45.4294C147.063 50.8579 144.205 55.6724 140.204 59.4705C138.958 60.6528 141.997 61.0511 141.997 61.0511C135.073 68.1271 124.956 70.8889 115.551 67.6305C115.381 67.5717 115.213 67.5104 115.048 67.4476C110.892 65.8609 106.261 65.9746 102.271 67.9353L101.539 68.2954L101.522 63.7699L104.325 62.3656L105.598 61.0731C107.387 62.3584 103.659 61.029 103.659 61.029C103.659 61.029 107.478 57.2177 105.689 55.9325C103.711 53.2496 102.601 50.0402 102.502 46.724L102.374 42.4261C100.177 42.2718 98.1737 42.7668 96.4127 43.892C95.6724 44.365 95.0199 44.9598 94.4262 45.6033L93.1741 46.9602C92.5 45.0117 91.0482 37.7046 96.1077 36.1975C96.7771 35.9983 98.04 36.1107 99.5578 36.3918C106.385 37.656 112.377 41.6551 116.278 47.3268L116.52 47.6797H116.521Z",
    fill: "#968879",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9193 48.5879L91.0688 53.6615C91.0688 53.6615 90.9139 54.7889 92.143 55.6749",
    fill: "#EDD6BF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9193 48.5879L91.0688 53.6615C91.0688 53.6615 90.9139 54.7889 92.143 55.6749",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M104.409 55.9219L106.852 52.7227C109.382 54.1871 109.874 57.9956 107.952 61.2296C106.03 64.4634 102.421 65.8977 99.8916 64.4333",
    fill: "#EDD6BF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M104.409 55.9219L106.852 52.7227C109.382 54.1871 109.874 57.9956 107.952 61.2296C106.03 64.4634 102.421 65.8977 99.8916 64.4333",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M102.512 48.7719C102.436 48.7719 102.36 48.7436 102.302 48.6867C101.795 48.1929 101.176 47.8224 100.511 47.6157C100.354 47.5668 100.266 47.401 100.316 47.2457C100.366 47.0901 100.534 47.0037 100.691 47.0529C101.446 47.2876 102.148 47.7075 102.722 48.2671C102.84 48.3818 102.841 48.5681 102.725 48.6843C102.666 48.7426 102.589 48.7719 102.512 48.7719Z",
    fill: "#002340"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2127 45.8812C97.1345 45.8812 97.0563 45.8511 96.9975 45.7911C96.5187 45.301 95.804 45.0933 95.1321 45.2474C94.9719 45.2856 94.8107 45.1861 94.773 45.0272C94.7355 44.8687 94.8354 44.7098 94.9961 44.6729C95.8719 44.4714 96.8036 44.7428 97.4275 45.3814C97.5419 45.4985 97.5386 45.6854 97.4197 45.7983C97.3616 45.8534 97.2869 45.8809 97.2122 45.8809L97.2127 45.8812Z",
    fill: "#002340"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7858 50.5211C92.6664 50.5211 92.5467 50.4712 92.4595 50.3849C92.3767 50.3032 92.3262 50.1853 92.3262 50.0675C92.3262 49.9449 92.3767 49.8315 92.4595 49.7453C92.5698 49.6409 92.7263 49.591 92.8779 49.6228C92.9056 49.6272 92.9332 49.6362 92.9606 49.6453C92.988 49.659 93.0157 49.6726 93.0433 49.686C93.0665 49.7042 93.0894 49.7223 93.1122 49.7451C93.1995 49.8312 93.2455 49.9446 93.2455 50.0672C93.2455 50.1851 93.1995 50.3032 93.1122 50.3846C93.0891 50.4074 93.0662 50.4256 93.0433 50.4437C93.0157 50.4571 92.988 50.4754 92.9606 50.4844C92.933 50.4978 92.9053 50.5025 92.8779 50.5117C92.8457 50.5161 92.8183 50.5208 92.7858 50.5208V50.5211Z",
    fill: "#002340"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4641 53.5465C98.3446 53.5465 98.2249 53.4966 98.1377 53.415C98.0962 53.3696 98.064 53.3242 98.0411 53.2651C98.0182 53.2105 98.0044 53.1517 98.0044 53.0926C98.0044 52.9745 98.0549 52.8566 98.1377 52.7705C98.3077 52.6025 98.6205 52.6025 98.7905 52.7705C98.8732 52.8566 98.9237 52.9745 98.9237 53.0926C98.9237 53.1515 98.9099 53.2105 98.887 53.2651C98.8639 53.3239 98.8317 53.3696 98.7905 53.415C98.7032 53.4966 98.5835 53.5465 98.4641 53.5465Z",
    fill: "#002340"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0415 66.8919C93.4324 67.6972 96.3871 66.8542 97.8768 64.8406L104.409 55.9227L113.397 43.8867",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M116.521 47.6797C117.23 48.7555 117.459 49.7255 117.201 50.5633C116.875 51.6222 115.889 52.0523 115.848 52.0699",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6753 56.7559C90.613 57.8234 91.5062 59.2608 95.7419 58.3689C93.7301 60.9436 92.2895 61.4888 91.1371 61.0833C90.0133 60.6877 90.1855 59.6725 90.4921 57.6485",
    fill: "#EDD6BF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6753 56.7559C90.613 57.8234 91.5062 59.2608 95.7419 58.3689C93.7301 60.9436 92.2895 61.4888 91.1371 61.0833C90.0133 60.6877 90.1855 59.6725 90.4921 57.6485",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M104.986 23.9102L100.887 33.3417",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6978 33.832L88.2546 37.8766",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7603 23.498L93.6195 33.0269",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0642 153.751C90.1772 154.088 89.2903 154.426 88.4034 154.764C85.5342 150.973 85.1678 146.446 87.3913 142.254C88.3212 142.448 89.2511 142.643 90.1813 142.838C88.2415 146.494 88.5611 150.444 91.0642 153.751V153.751Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4392 42.9861C45.7125 43.3829 38.1533 51.4861 38.5554 61.0849C38.9575 70.684 47.1685 78.1439 56.8951 77.7471C65.0323 77.4151 71.6488 71.6885 73.3597 64.206L79.9863 59.3949L72.98 55.14C70.6492 47.8222 63.5763 42.654 55.4389 42.9858L55.4392 42.9861Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7514 56.4456C47.0408 53.7469 49.4918 51.7909 52.2265 52.0765C54.2367 52.2865 55.8362 53.6511 56.4297 55.4304C57.3875 53.8131 59.2413 52.8091 61.2513 53.019C63.9857 53.3047 65.968 55.7237 65.6785 58.4222C65.5604 59.5251 65.077 60.4998 64.3651 61.2523L64.3687 61.2542L54.7358 71.2271L47.4409 59.5022L47.4454 59.501C46.9022 58.6148 46.6324 57.5554 46.7514 56.4459V56.4456Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7405 85.9599C29.3324 85.1127 28.9242 84.2655 28.5161 83.418C32.1296 80.3086 36.6769 79.6065 41.0803 81.4782C40.9538 82.408 40.8275 83.3379 40.701 84.2677C36.8597 82.6349 32.8931 83.2473 29.7407 85.9599H29.7405Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5556 175.247L20.7539 184.609L23.375 186.464L30.1766 177.101L27.5556 175.247Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M170.341 137.207C170.712 138.071 171.083 138.934 171.454 139.798C167.708 142.752 163.135 143.261 158.817 141.205C158.984 140.281 159.15 139.358 159.317 138.434C163.084 140.228 167.073 139.784 170.341 137.207H170.341Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2032 157.394L32.1006 148.109L29.4982 146.227L22.6008 155.512L25.2032 157.394Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1179 87.7188C44.8632 88.3009 45.6085 88.8834 46.3539 89.4658C44.5029 93.8305 40.7372 96.4419 35.9488 96.6811C35.6463 95.7917 35.3435 94.9025 35.041 94.0131C39.2181 93.8044 42.5032 91.5263 44.1179 87.7188Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3818 69.6966L24.1973 62.1562L22.0838 59.7499L13.2684 67.2903L15.3818 69.6966Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6154 133.061C44.5657 133.037 45.516 133.014 46.4665 132.99C47.8762 137.512 46.6775 141.898 43.1545 145.107C42.345 144.615 41.5355 144.123 40.7261 143.631C43.7995 140.831 44.8451 137.006 43.6154 133.061V133.061Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0475 168.281L52.5016 177.107L50.0406 179.153L42.5864 170.328L45.0475 168.281Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1396 96.5656C88.0404 96.2656 88.9411 95.9658 89.8419 95.666C92.5439 99.5745 92.7134 104.113 90.3099 108.207C89.3893 107.974 88.4684 107.74 87.5478 107.506C89.6445 103.935 89.4969 99.9753 87.1396 96.5656Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M135.225 132.193L126.364 124.705L124.265 127.124L133.126 134.612L135.225 132.193Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M144.688 156.674C145.332 155.984 145.977 155.295 146.622 154.605C150.892 156.756 153.246 160.659 153.127 165.389C152.206 165.619 151.284 165.85 150.363 166.081C150.467 161.954 148.413 158.55 144.688 156.674Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2236 204.082C77.7154 204.874 77.2072 205.667 76.699 206.46C72.1058 205.104 69.0771 201.684 68.3311 197.01C69.1953 196.62 70.0594 196.228 70.9239 195.838C71.5749 199.915 74.2168 202.899 78.2239 204.082L78.2236 204.082Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1418 111.264L56.6626 103.357L54.4464 105.672L62.9257 113.579L65.1418 111.264Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8051 1.52768L98.2979 12.1523L101.276 10.926L96.783 0.301311L93.8051 1.52768Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M102.295 39.7812L102.502 46.7263L102.295 39.7812Z",
    fill: "#968879"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M102.295 39.7812L102.502 46.7263",
    fill: "none",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3345 43.243C36.647 42.595 35.9595 41.9471 35.272 41.2994C37.5241 37.1223 41.5183 34.8661 46.3087 35.0648C46.5265 35.9781 46.7448 36.8911 46.9625 37.8043C42.7837 37.6308 39.2992 39.5992 37.3345 43.243Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M130.115 7.76758L140.464 13.1137L138.961 15.934L128.611 10.5879L130.115 7.76758Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3188 26.9319C73.2585 27.0733 74.1982 27.215 75.138 27.3567C75.7204 32.0532 73.7594 36.1622 69.7199 38.7106C69.0108 38.0857 68.3014 37.4613 67.5923 36.8365C71.1163 34.6135 72.827 31.0288 72.3188 26.9316V26.9319Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M151.472 76.7973L154.56 65.6953L151.448 64.8524L148.36 75.9544L151.472 76.7973Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M128.228 47.6133C129.149 47.8485 130.069 48.084 130.989 48.3195C131.083 53.05 128.708 56.9404 124.426 59.0691C123.785 58.3762 123.144 57.6836 122.503 56.9908C126.239 55.1338 128.311 51.7399 128.228 47.6133Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M126.181 104.123C125.514 103.455 124.847 102.786 124.181 102.117C126.563 98.0113 130.626 95.8783 135.408 96.2238C135.597 97.1432 135.786 98.0627 135.975 98.9821C131.804 98.6808 128.259 100.542 126.181 104.123H126.181Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0824 37.5491L18.9438 31.8535L17.3476 34.6207L27.4862 40.3163L29.0824 37.5491Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M32.204 120.951C38.1326 115.1 38.1326 105.614 32.204 99.7638C26.2754 93.9131 16.6633 93.913 10.7347 99.7638C4.80608 105.614 4.80609 115.1 10.7347 120.951C16.6633 126.802 26.2754 126.802 32.204 120.951Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2212 104.154C6.75503 110.07 8.812 117.666 14.8064 121.086",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1322 121.465L34.6113 117.856L38.5402 117.355L36.1322 121.465Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M145.966 119.917L149.728 118.49L149.292 122.445L145.966 119.917Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M179.551 104.445L156.234 86.5332L138.084 109.544L161.401 127.456L179.551 104.445Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M156.509 90.6973L147.951 101.548",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M115.032 198.774L124.371 191.902L122.441 189.348L113.102 196.219L115.032 198.774Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGirl);
export default __webpack_public_path__ + "static/media/SuccessGirl.6ff9f6c1bc27cba7cb8d92ca11dba29e.svg";
export { ForwardRef as ReactComponent };